/**
 * Creates query strings for results. Used in href of results list and request to FFSS
 * User will not actually use this href unless they interact with the anchors in a way other than
 * normal point-and-click.
 *
 * @param {array} appliedFilters - List of objects containing filtered data (DDC.InvData.getAppliedFilters())
 * @returns {string}
 */
export const getFilterParams = (appliedFilters = []) => {
	if (appliedFilters.length) {
		const filterParams = appliedFilters.map((filter) =>
			filter.values.map((i) => `${filter.id}=${i.value}`)
		);
		return filterParams.join('&');
	}
	return '';
};

export const sanitizeListingConfigId = (listingConfigId = '') => {
	return (
		listingConfigId
			.split(',')
			.map((item) => item.trim())
			.filter(Boolean)
			.join() || 'auto-new,auto-used'
	);
};

/**
 * Calls setFilterSearchEventData for the result clicked.
 *
 * @param event
 * @param facetInfo
 * @param isNLSFacetInfo
 */
export const applyFilters = (event, facetInfo, isNLSFacetInfo = false) => {
	event.preventDefault();
	// Handling for NLS facetInfo is in the `else if` block
	if (!isNLSFacetInfo) {
		window.DDC.InvData.spellcheckSearchTerm(event, facetInfo);
	} else if (facetInfo) {
		window.DDC.InvData.clearFilters();

		// Persisting geoZip and geoRadius
		const appliedFilters = window.DDC.InvData.getAppliedFilters();
		const geoData = appliedFilters
			.filter((key) => key.id.includes('geo'))
			.reduce((obj, item) => {
				return {
					...obj,
					[item.id]: item.values[0].value
				};
			}, {});

		const newFacetInfo = {
			...geoData,
			...facetInfo
		};

		Object.keys(newFacetInfo).forEach((name) => {
			// Handle array values in NLS facetInfo
			const facetValue = newFacetInfo[name];
			const valueIsArray = isNLSFacetInfo && Array.isArray(facetValue);
			const filterValues = valueIsArray ? facetValue : [facetValue];
			const filterValue = valueIsArray ? facetValue[0] : facetValue;

			window.DDC.InvData.setFilterSelections({
				filterName: name,
				filterValues,
				filterValue,
				element: event.target
			});
		});
	}
};
